import { render, staticRenderFns } from "./Cart3.vue?vue&type=template&id=4c6619bf&"
import script from "./Cart3.vue?vue&type=script&lang=js&"
export * from "./Cart3.vue?vue&type=script&lang=js&"
import style0 from "./Cart3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
